import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { BsArrowRight } from "react-icons/bs";

const Card = (props) => {
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  if (modal) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }
  return (
    <>
      <div className="box btn_shadow ">
        <div className="box_img">
          <img src={props.image} alt="..." onClick={toggleModal} />
        </div>
        <div className="category d_flex">
          <span onClick={toggleModal}>{props.date}</span>
          {/*<label>
            <i className='far fa-heart'></i> {props.date}
          </label>*/}
        </div>
        <div className="title">
          <h2 onClick={toggleModal}>{props.title_one}</h2>
          <a href="#popup" className="arrow" onClick={toggleModal}>
            <BsArrowRight />
          </a>
        </div>
      </div>

      {/* Popup box */}
      {modal && (
        <div className="modal modal-blog">
          <div onClick={toggleModal} className="overlay"></div>
          <div className="modal-content">
            <div className="modal-img left">
              <img src={props.image} alt="..." />
            </div>
            <div className="modal-text right">
              <span>{props.date}</span>
              <p>{props.title_one}</p>
              <p>{props.desc_one}</p>

              <p>{props.title_two}</p>
              <p>{props.desc_two}</p>

              <p>{props.title_three}</p>
              <p>
                <em>{props.desc_three}</em>
              </p>

              <button className="close-modal btn_shadow" onClick={toggleModal}>
                <FaTimes />
              </button>

              {/*---------Leave Message----------  */}
              {/* <div className="contact mtop">
                <h2>Leave a Reply</h2>

                <form className="blog_contact d_flex">
                  <div className="left">
                    <input type="text" placeholder="Name" />
                    <input type="email" placeholder="Email" />
                    <input type="text" placeholder="Website" />
                    <button className="btn_shadow">SUBMIT NOW</button>
                  </div>
                  <div className="right">
                    <textarea
                      cols="30"
                      rows="12"
                      placeholder="Comment"
                    ></textarea>
                  </div>
                </form>
              </div> */}
              {/*---------Leave Message----------  */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Card;
